module.exports = __webpack_public_path__ + "static/img/role1.a11ec05.png";


//////////////////
// WEBPACK FOOTER
// ./static/default/img/index1/role1.png
// module id = yhib
// module chunks = 7